import React from 'react'
import { CustomModal } from '../../../ayria'

const PlatformModal = ({ showModal, title, content, toggle }) => {
  return <CustomModal showModal={showModal} title={title} content={content} toggle={toggle} isPlatformTheme={true} />
}

export default PlatformModal
